
import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  name: 'exTotal'
})
export default class extends Vue {
  @Prop({ required: true }) private info!: any
  private subProductList: any[] = []
  private subProductName: any = ''

  private dialogVisible: boolean = false

  private handleClose() {
    this.dialogVisible = false
  }
  private openSubProductList(list: any) {
    this.dialogVisible = true
    this.subProductList = list.product_sub_list
    this.subProductName = list
    console.log(list, 'list')
  }

  mounted() {}
}
